import styled from "styled-components";
import { theme } from "uikit";

const Subtext = styled.div`
	font-family: "Lato";
	font-style: normal;
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;

	color: ${theme.colors.secondary};

	${theme.longWord}
`;

export default Subtext;
